import React from "react";

import { useUnhideNotice } from "lib/hooks/api/notices/useUnhideNotice";
import Button from "../ui/button/Button";
import Tooltip from "../ui/tooltip/Tooltip";

type Props = {
  notice: {
    id: string;
    score: number | null | undefined;
    signalTypes: Record<string, string[]> | undefined;
    procurementStage: { id: string; stage: string };
  };
  contextSource: string;
  size?: "small" | "default";
};

export function RestoreNoticeButton({ notice, size = "default", contextSource }: Props) {
  const { unhideNotice } = useUnhideNotice(
    {
      guid: notice.id,
      procurementStage: notice.procurementStage,
      score: notice.score,
      signalTypes: notice.signalTypes,
    },
    contextSource,
  );
  return (
    <Tooltip content={size === "small" ? "Restore notice" : null}>
      <Button onClick={unhideNotice} icon="refreshCcw01" buttonType="secondary">
        {size === "default" ? "Restore" : null}
      </Button>
    </Tooltip>
  );
}
